import Vue from "vue";
import VueChimera from "vue-chimera";

Vue.use(VueChimera);
